import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_TECHNICAL } = ROLES;

const ALLOWED_ROLES_VIEW_API_KEYS = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_TECHNICAL];

export function canViewAndCopyApiKeys(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_VIEW_API_KEYS);
}
